__turbopack_context__.v({
  "markdown": "markdown-module__6z1QOa__markdown",
});
